import axios, { type AxiosResponse } from "axios";

export default class KitsApi {
   public static getRegistrationStatus = async (code): Promise<AxiosResponse> => {
      const response = await axios.get(`/kits/${code}/registration-status`);
      return response;
   };
}
